import { useEffect } from "react";
import { getUrlQueryParams } from "../utils";
import { STORAGE } from "../constants";

// 针对客户端带userkey的场景，需要保存userkey到sessionStorage
export function useSaveUserkey() {
  useEffect(() => {
    const queryParams = getUrlQueryParams(window.location.href);
    if (queryParams.rayvision_token) {
      sessionStorage.setItem(STORAGE.USER_KEY, queryParams.rayvision_token);
    }
  }, []);
}
